import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { i18n } from '@/packages/i18n';
import useApiHelpers from '@/composables/api/helpers';
import { useGlobalStore } from '@/stores/globalStore';
import { useIdentityQueueStore } from '@/stores/identityQueueStore';
import useModalActions from '@/composables/store/modal/useModalActions';

export default function useDofpCommon(arrayCount) {
  const tradingExp = ref(false);
  const responses = ref(new Array(arrayCount).fill(undefined));
  const globalStore = useGlobalStore();
  const identityQueueStore = useIdentityQueueStore();
  const route = useRoute();
  const router = useRouter();
  const { postRequest } = useApiHelpers();
  const { toggleDofpModal } = useModalActions();
  const { t } = i18n.global;

  const updateResponse = (index, answerValue, question) => {
    const [answer, answerString] = answerValue.split('.');

    responses.value[index] = {
      question,
      answer,
      answerString: answerString.trim(),
    };
  };

  const findValueFromAnswers = (answer) => answer.split('.')[0];
  const trimValueFromAnswer = (answer) => {
    const [first, ...rest] = answer.split('.');
    const remainder = rest.join('.');
    return remainder;
  };

  const updateYesNoResponse = (answerValue, question) => {
    tradingExp.value = answerValue;
    const answer = answerValue ? 'B' : 'A';
    const answerString = answerValue ? 'Yes' : 'No';
    responses.value[0] = {
      question,
      answer,
      answerString,
    };
  };

  const formValuesFilled = computed(() => responses.value.every((response) => typeof response !== 'undefined'));

  const handleFormSuccessCallback = (nextRoute) => {
    router.push(nextRoute);
  };

  const bindModalContent = (modalNumber, primaryBtnText, secondaryBtnText) => ({
    title: t('dofpFailureModal.text.title'),
    body: `<p class="bodycopy">${t(
      `dofpFailureModal.modal${modalNumber.toString()}.body`,
      {
        riskSummaryLink: `<a target='_blank' href='https://banxa.com/due-diligence/'>${t(
          'dofpFailureModal.text.riskSummaryLink',
        )}</a>`,
      },
    )}</p>`,
    primaryBtnText: t('dofpFailureModal.modal1.primaryBtnText'),
    secondaryBtnText: t('dofpFailureModal.modal.secondaryBtnText'),
  });

  const handleFormSubmit = (formNumber, formType) => {
    const payload = {
      form: formNumber,
      formType,
      responses: responses.value,
    };

    globalStore.setIsFormLoading(true);

    postRequest(
      '/customers/questionnaire',
      payload,
      async (res) => {
        identityQueueStore.updateToNextRoute();
        identityQueueStore.fetchNextIdentityRoute(route).then((nextRoute) => {
          // triggers after faiing dofp-questionnaire 1
          if (
            nextRoute.indexOf('/identity/dofp/questionnaire/buy/2') >= 0
            || nextRoute.indexOf('/identity/dofp/questionnaire/sell/2') >= 0
          ) {
            toggleDofpModal(true, bindModalContent(1));

            handleFormSuccessCallback(nextRoute);
          } else {
            handleFormSuccessCallback(nextRoute);
          }
        });
      },
      () => {
        // trigger after failing dofp-questionnaire 2
        if (formNumber) {
          toggleDofpModal(true, bindModalContent(formNumber));
        }
      },
    );
  };

  return {
    tradingExp,
    responses,
    updateResponse,
    findValueFromAnswers,
    trimValueFromAnswer,
    updateYesNoResponse,
    formValuesFilled,
    handleFormSubmit,
  };
}
